
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","d":"M15.099 18.854c-.07 1.248-.853 2.039-1.934 2.039s-1.863-.791-1.934-2.04H15.1zm4.94-1.029H6.291v-.096c.105-.352.694-.976 1.204-1.521.791-.861.94-2.426 1.099-4.271.167-3.261 1.177-4.527 2.707-4.94.255-.07.395-.184.422-.422.061-.905.588-1.573 1.441-1.573.853 0 1.38.668 1.441 1.573.027.237.167.352.422.422 1.53.413 2.54 1.679 2.707 4.94.159 1.845.308 3.41 1.099 4.271.51.545 1.099 1.169 1.204 1.52v.097zm-6.874 4.026c1.714 0 2.936-1.345 2.988-2.997h4.158c.632 0 1.028-.343 1.028-.853 0-.888-.861-1.652-1.6-2.435-.712-.773-.782-2.355-.931-3.735-.141-3.006-1.029-5.062-3.261-5.792C15.292 4.861 14.387 4 13.165 4c-1.222 0-2.127.861-2.373 2.04-2.241.729-3.12 2.785-3.27 5.791-.149 1.38-.22 2.962-.931 3.735C5.853 16.35 5 17.113 5 18.001c0 .51.387.853 1.02.853h4.157c.052 1.643 1.274 2.997 2.988 2.997z","fill-rule":"evenodd"}})])
          )
        }
      }
    